import { Stack, styled } from '@mui/material'

export const StyledStack = styled(Stack)(({ theme }) => ({
  width: 128,
  height: 100,
  backgroundColor: theme.palette.greyBlue.main,
  borderRadius: theme.spacing(1.5),
}))
